import './style.css'
import { Link } from "react-router-dom"
import { useEffect, useMemo, useState } from 'react'
import { storage } from '../../firebase.config'
import { getDownloadURL, ref } from 'firebase/storage'

function Annonce(props) {
  const [url, setUrl] = useState(null)

  const prixAffiche = useMemo(() => {
    const v = props.data?.prixFix != null ? props.data.prixFix : props.data?.prix
    return v != null ? `${v} €` : ''
  }, [props.data])

  useEffect(() => {
    let mounted = true

    async function initUrl() {
      try {
        // Essayer d'abord avec .webp
        let theUrl;
        try {
          theUrl = await getDownloadURL(ref(storage, `images/map/${props.data.id}_800x800.webp`))
        } catch (e) {
          // Si ça fail, essayer sans extension
          theUrl = await getDownloadURL(ref(storage, `images/map/${props.data.id}_800x800`))
        }
        if (mounted) setUrl(theUrl)
      } catch (e) {
        // optionnel: console.log(e)
        if (mounted) setUrl(null)
      }
    }

    if (props.data?.id) initUrl()
    return () => { mounted = false }
  }, [props.data?.id])

  return (
    <Link
      className="annonceLink"
      to={{ pathname: "/annonce" }}
      state={{ data: props.data, url, horaires: props.horaires, prix: props.prix, cat: props.cat }}
      preventScrollReset={true}
    >
      <article className="annonce">
        <div className="image" style={url ? { backgroundImage: `url(${url})` } : undefined}>
          {!url && <div className="imgFallback">Image</div>}
          {!!prixAffiche && <div className="badgePrix">{prixAffiche}</div>}
        </div>

        <div className="infos">
          <h3 className="title" title={props.data?.nom}>{props.data?.nom}</h3>
          <p className="model" title={props.data?.model}>{props.data?.model}</p>

          <div className="metaRow">
            {props.data?.categorie ? <span className="chip">{props.data.categorie}</span> : <span />}
            <span className="cta">Voir</span>
          </div>
        </div>
      </article>
    </Link>
  )
}

export default Annonce
